import Indicator from 'mint-ui/lib/indicator';
import 'mint-ui/lib/indicator/style.css';

export default Indicator;
